import { gql, useQuery } from '@apollo/client'

import {
  CurrentUserFragmentDoc,
  PickupUserEventFragmentDoc,
  PickupUserEventsQuery,
  PickupUserEventsQueryVariables,
} from '@/clients/utoniq-core/schema'
import { config } from '@/config'
import { useCurrentUser } from '@/core'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { userClaims } = useCurrentUser()
  const { data, loading, fetchMore } = useQuery<
    PickupUserEventsQuery,
    PickupUserEventsQueryVariables
  >(QUERY, {
    notifyOnNetworkStatusChange: true,
  })

  const isNextFetch = !!data

  return {
    state: {
      user: data?.user ?? null,
      events: data?.pickupUserEvents ?? null,
      loading: loading && !isNextFetch,
      hasNextPage: !!data?.pickupUserEvents?.pageInfo.hasNextPage,
      followArtists: data?.user?.organizationFollowees ?? null,
      memberArtists: data?.user?.organizationPatrons ?? null,
      isArtist: !!userClaims?.orgs?.[config.organizationId]?.artist,
    },
    actions: {
      async onFetchMore() {
        await fetchMore({
          variables: {
            pageInput: {
              cursor: data?.pickupUserEvents?.pageInfo.endCursor,
            },
          },
        })
      },
    },
  }
})

const QUERY = gql`
  query PickupUserEvents($pageInput: PageInput) {
    user {
      ...CurrentUser
    }
    pickupUserEvents(pageInput: $pageInput) {
      edges {
        node {
          ... on Event {
            ...PickupUserEvent
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${CurrentUserFragmentDoc}
  ${PickupUserEventFragmentDoc}
`
